// extracted by mini-css-extract-plugin
export default {"header":"E3vr8fz3odE86zQ1yxNV"};